module.exports = __webpack_public_path__ + "static/img/koubei.0ef5982.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/koubei.png
// module id = 85
// module chunks = 0